import { ComponentChildren } from 'preact';

import { ArrowDown, ArrowUp } from '@travel/icons/ui';

import IconTextButton from 'components/IconTextButton';
import cx from '@travel/ui/utils/classnames';

import styles from './collapsibleSection.module.scss';

type Props = {
  children?: ComponentChildren;
  className?: string;
  isOpen: boolean;
  textDisplayedWhileClosed: ComponentChildren;
  textDisplayedWhileOpen: ComponentChildren;
  onClickOpen?: () => void;
  onClickClose?: () => void;
};

const CollapsibleSection = (props: Props) => {
  const {
    children,
    className,
    isOpen,
    textDisplayedWhileClosed,
    textDisplayedWhileOpen,
    onClickOpen,
    onClickClose,
  } = props;
  return (
    <>
      {!isOpen && (
        <IconTextButton
          icon={<ArrowDown spacing={4} size={16} />}
          iconPosition={'right'}
          text={textDisplayedWhileClosed}
          onClick={onClickOpen}
          className={cx(styles.defaultButtonWrapper, className)}
          data-testid="collapsibleSection-iconTextButton-open"
        />
      )}
      {isOpen && (
        <>
          {children}
          <IconTextButton
            icon={<ArrowUp spacing={4} size={16} />}
            iconPosition={'right'}
            text={textDisplayedWhileOpen}
            onClick={onClickClose}
            className={cx(styles.defaultButtonWrapper, className)}
          />
        </>
      )}
    </>
  );
};

export default CollapsibleSection;
